module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_8004.5b29c922.png";